"use client";

import { ReactNode, useEffect } from "react";

import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";

import { CurrentAccountIdProvider } from "@zapier/identity";

import {
  FullStory,
  TrackRouting,
  initializeDatadogRum,
} from "../observability";

import { isDatadog } from "../utils/isDatadog";
import ManageCookiesLink from "./ManageCookiesLink";
import { DatadogInit } from "./DatadogInit";
import {
  UserSessionProvider,
  useUserSession,
} from "../context/UserSessionProvider";

interface Props {
  children: ReactNode;
}

function AppLayoutContent({ children }: Props) {
  const { user } = useUserSession();

  useEffect(() => {
    if (!isDatadog()) {
      initializeDatadogRum();
    }
  }, []);

  return (
    <CurrentAccountIdProvider>
      <TrackRouting>
        <div>
          {!isDatadog() && <DatadogInit />}
          {children}
          <footer
            style={{
              padding: "20px",
              textAlign: "center",
              borderTop: "1px solid var(--zds-colors-neutral-300)",
              marginTop: "24px",
            }}
          >
            <ManageCookiesLink />
          </footer>
          <Analytics />
          <SpeedInsights />
          <FullStory user={user ?? undefined} />
        </div>
      </TrackRouting>
    </CurrentAccountIdProvider>
  );
}

export default function AppLayout({ children }: Props) {
  return (
    <UserSessionProvider>
      <AppLayoutContent>{children}</AppLayoutContent>
    </UserSessionProvider>
  );
}
